module.exports = __webpack_public_path__ + "img/thumb-anna-off.37594566.jpg";